const responsiveCustomText = (texts) => {
    texts.forEach(text => {
        const currentSize = text.style.fontSize;
        const regex = /px/i;
        const isInPixel = currentSize.match(regex);

        if (isInPixel) {
            const sizeNumberString = currentSize.replace(regex, "");
            const sizeNumber = parseFloat(sizeNumberString);
            const newSize = sizeNumber * 0.75;
            text.style.fontSize = `${newSize}px`;
            return;
        } else {
            return;
        }
    })
}

export { responsiveCustomText };